'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z' });

var FirstPage = function FirstPage(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

FirstPage = (0, _pure2.default)(FirstPage);
FirstPage.muiName = 'SvgIcon';

exports.default = FirstPage;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/FirstPage.js
// module id = 732
// module chunks = 0